import React from 'react';
import style from './additionalInfo.module.scss';
import CateringIcon from 'acscp/assets/catering.svg';
import { FormattedMessage } from 'react-intl';
import { withCollapsable } from 'acscp/components/common/collapsable';
import { Title } from 'acscp/components/itinerary/collapsableSections';
import { TelephoneLink } from 'acscp/components/common/telephoneLink';
import { MailTo } from 'acscp/components/common/mailToLink';
import { AdditionalItem } from 'acscp/components/itinerary/additionalItem';

const CateringContent: React.SFC<{catering: string | null}> = ({catering}) => {
    if (!catering) {
        return null;
    }

    return (
        <div className={style.Container}>
            <div className={style.InnerContainer}>
                <AdditionalItem
                    icon={CateringIcon}
                    label={''}
                >
                    <div>{catering}</div>
                </AdditionalItem>
            </div>
        </div>
    );
};

const Catering = withCollapsable(
    (
        <Title>
            <FormattedMessage id={'web.components.itinerary.catering'} defaultMessage={'CATERING'} />
        </Title>
    ),
    CateringContent);

export { Catering };
